import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Route } from '../../enums';
import { useAuthStore } from '../../store/auth.store';
import { api } from '../../services/api';
import type { Principal } from '../../types';

/** Guards private routes. With a token but no principal yet, it loads /api/me once. */
export function RequireAuth() {
  const token = useAuthStore((s) => s.accessToken);
  const principal = useAuthStore((s) => s.principal);
  const setSession = useAuthStore((s) => s.setSession);
  const clear = useAuthStore((s) => s.clear);
  const [checking, setChecking] = useState(Boolean(token && !principal));
  const location = useLocation();

  useEffect(() => {
    if (token && !principal) {
      api
        .get<Principal>('/api/me')
        .then((p) => setSession(token, p))
        .catch(() => clear())
        .finally(() => setChecking(false));
    }
  }, [token, principal, setSession, clear]);

  // Remember where the person was heading (e.g. the authorize page an agent opened) so sign-in brings them back.
  if (!token) {
    const wanted = `${location.pathname}${location.search}`;
    return <Navigate to={wanted === Route.Apps ? Route.Login : `${Route.Login}?redirect=${encodeURIComponent(wanted)}`} replace />;
  }
  if (checking) return null;
  return <Outlet />;
}
